<template>
	<span style="color: #F26F2A;" :endTime="endTime" :endText="endText">
		<slot>{{content}}</slot>
	</span>
</template>

<script>
import { number } from 'echarts'
import { Result } from 'element-ui'
	export default {
		data(){
			return {
				content: '',
				isHour_:this.isHour
			}
		},
		props:{//接收父组件的数据
			endTime:{type:String,default:''},
			endText:{type:String,default:'活动已结束'},
			isHour:{
				type:Number,
				default:0
			},
			order:{
				type:Object,
				default:()=>{return {}}
			}
		},
		watch: {//监听时间的变化
			endTime() {
				this.countdowm(this.endTime)
			}
		},
		mounted () {
			this.countdowm(this.endTime)
		},
		methods: {
			countdowm(times){
				if(this.isHour_ == 1){
					//距离直播时间
					this.count2(times)
				}else{
					//倒计时24小时
					this.count1(times)
				}
			},
			count1(times){
				let timestamp =  new Date(times)
				let self = this;
				let timer = setInterval(function(){
					var nowtime = new Date()   //获取当前时间
					var time1 = times
					var date = new Date(time1.replace(/-/g, '/'));
					var starttime = new Date(date);  //定时开始时间
					starttime = Date.parse(starttime)
					var endtime = new Date(starttime + 24 * 60 * 60 * 1000) //定时结束时间
					var lefttime = endtime.getTime() - nowtime.getTime()   //当前时间距离结束时间的毫秒数
					if (lefttime <= 0) lefttime = 0;
					var leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)),   //计算天数
					leftd=leftd>9?leftd:'0'+leftd
					var lefth = Math.floor(lefttime / (1000 * 60 * 60) % 24),   //计算小时数
					lefth=lefth>9?lefth:'0'+lefth
					var leftm = Math.floor(lefttime / (1000 * 60) % 60),   //计算分钟数
					leftm=leftm>9?leftm:'0'+leftm
					var lefts = Math.floor(lefttime / 1000 % 60);   //计算秒数
					lefts=lefts>9?lefts:'0'+lefts
					if(lefttime>0){
						self.content = lefth + " : " + leftm + " : " + lefts
					}else{
						clearInterval(timer);
						self.content = '已超时';
						self.$emit('cancel',self.order)
					}
				},1000);
			},
			count2(time){
				let that = this
				let timer = setInterval(()=>{
					var date = new Date();
					var now = date.getTime();  
					//设置截止时间  
					var str=time
					var endDate = new Date(str); 
					var end = endDate.getTime();  
					//时间差  
					var leftTime = end-now; 
					//定义变量 d,h,m,s保存倒计时的时间  
					var d,h,m,s;  
					if (leftTime>0) {  
						d = Math.floor(leftTime/1000/60/60/24)>=10 ? Math.floor(leftTime/1000/60/60/24) : '0'+Math.floor(leftTime/1000/60/60/24);  
						h = Math.floor(leftTime/1000/60/60%24)>= 10 ? Math.floor(leftTime/1000/60/60%24) :'0'+Math.floor(leftTime/1000/60/60%24);  
						m = Math.floor(leftTime/1000/60%60)>=10 ? Math.floor(leftTime/1000/60%60) : '0'+Math.floor(leftTime/1000/60%60);  
						s = Math.floor(leftTime/1000%60)>=10 ? Math.floor(leftTime/1000%60) :'0'+Math.floor(leftTime/1000%60);       
						that.content =  d + "天" + h + "小时" + m +'分'+s+'秒'
					}else{
						clearInterval(timer);
						that.content = '拼团结束';
					}  
				},1000)
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/countDown.vue